// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"73c296b0","151":"6c67d31d","163":"f0135c40","211":"d1fe7875","242":"179704ce","253":"ef2dde7b","340":"2c7cc3c2","427":"18ed5082","432":"892af7b0","565":"98165bd3","680":"aebc1c17","703":"becde6dc","918":"475fed7e","942":"f2473a91"}[chunkId] + ".chunk.js";
};